/* oxlint-disable react/jsx-no-target-blank */
import * as React from 'react';

import * as styles from './MainTitle.css';
import { trackTitleClick } from './trackings';
import { IPageState } from '../../types/page';
import { IFavoriteEntity } from '../../types/results';
import { TUser } from '../../types/user';
import { Text } from '../Text';

export interface IMainTitleStoreProps {
  page: IPageState;
  user: TUser;
  total: number;
  favoriteEntities: IFavoriteEntity[];
}

export interface IMainTitleOwnProps {
  title: string;
  fullUrl: string;
  entityId: number;
}

export type TMainTitleProps = IMainTitleStoreProps & IMainTitleOwnProps;

export function MainTitle(props: TMainTitleProps) {
  const { title, fullUrl, entityId, favoriteEntities, page, user, total } = props;

  return (
    <div className={styles['container']}>
      <Text color="blue" bold={true}>
        <a
          href={fullUrl}
          target="_blank"
          onClick={() => {
            trackTitleClick(page, user, entityId, favoriteEntities, total);
          }}
        >
          {title}
        </a>
      </Text>
    </div>
  );
}
